import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    comprador_form: {
        anombre_vehiculo: null,
        nombres: null,
        apellidos: null,
        tipo_documento: null,
        numero_documento: null,
        celular: null,
        correo: null,
        ciudad_id: null,
        ciudad_name: null,
        direccion: null
    },
    formapago_form: {
        descuento: 0,
        pagos_list: [
            {
                fecha: null,
                modalidad: null,
                observaciones: null,
                valor: 0
            }
        ]
    },
    retoma_form: {
        placa: null,
        marca: null,
        modelo: null,
        linea: null,
        version: null,
        color: null,
        kilometraje: null,
        motor_no: null,
        chasis_no: null,
        serie_no: null
    },
    condiciones: null
};
const mutations = {
    updateField,
    updateCierre: (state, payload) => {
        var size = Object.keys(payload.cierre).length;
        if (size > 0) {
            state.comprador_form = payload.cierre.comprador_form;
            state.formapago_form = {...state.formapago_form, ...payload.cierre.formapago_form};
            state.retoma_form = payload.cierre.retoma_form;
        }
    },
    cloneMetodoPago: (state, payload) => {
        state.formapago_form.pagos_list.push(payload);
    }
};

const getters = {
    getField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
